import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentRefinements, useStats } from 'react-instantsearch';

import { SearchFacetRefinementCheckboxes } from '@uncinc/react-searchkit';

import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { FACET_LIMIT, SCREEN_WIDE } from '../../../config/constants';
import Button from '../../Button';
import SearchFilterDialog from '../../Search/FilterDialog';
import type { SearchTopicalContentType } from '../types';

import './style.scss';

const Inner: React.FC = () => {
  const { t } = useTranslation();
  const { items } = useCurrentRefinements();

  const contentType = useMemo(() => (
    items.find((item) => item.attribute === 'type')?.refinements[0]?.value
  ), [items]) as SearchTopicalContentType | undefined;

  return (
    <div className="SearchTopical__AdvancedFacets">
      <SearchFacetRefinementCheckboxes
        attribute="targetAudience"
        title={t('components.search.facets.target_audience.label')}
        sortBy={['count:desc']}
        limit={FACET_LIMIT}
        showMoreText={t('components.search.facets.show_more.label')}
        showMore
      />

      <SearchFacetRefinementCheckboxes
        attribute="theme"
        title={t('components.search.facets.theme.label')}
        sortBy={['count:desc']}
        limit={FACET_LIMIT}
        showMoreText={t('components.search.facets.show_more.label')}
        showMore
      />

      {contentType !== 'event' && (
        <SearchFacetRefinementCheckboxes
          attribute="article_type"
          title={t('components.search.facets.article_type.label')}
          sortBy={['count:desc']}
          limit={FACET_LIMIT}
          showMoreText={t('components.search.facets.show_more.label')}
          showMore
        />
      )}
    </div>
  );
};

const SearchTopicalAdvancedFacets: React.FC = () => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const { nbHits } = useStats();

  if (width < SCREEN_WIDE) {
    return (
      <SearchFilterDialog
        title={t('components.search.facets.title')}
        openButtonProps={{
          iconPosition: 'left',
        }}
      >
        {({ closeDialog }) => (
          <>
            <Inner />
            <div className="SearchFacets__submit">
              <Button className="w-auto" onClick={closeDialog}>
                {t('searchkit.buttons.refine', { count: nbHits })}
              </Button>
            </div>
          </>
        )}
      </SearchFilterDialog>
    );
  }

  return (
    <>
      <h2 className="SearchFacets__title mb-8">
        {t('components.search.facets.title')}
      </h2>

      <Inner />
    </>
  );
};

export default SearchTopicalAdvancedFacets;
